/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_3_ProblemInputs */

const es_home_usecases_item_3_problem = /** @type {(inputs: Home_Usecases_Item_3_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nuevo empleado necesita aprender procesos y documentación sin molestar al equipo.`)
};

const en_home_usecases_item_3_problem = /** @type {(inputs: Home_Usecases_Item_3_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new employee needs to learn processes and documentation without bothering the team.`)
};

/**
* | output |
* | --- |
* | "A new employee needs to learn processes and documentation without bothering the team." |
*
* @param {Home_Usecases_Item_3_ProblemInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_3_problem = /** @type {((inputs?: Home_Usecases_Item_3_ProblemInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_3_ProblemInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_3_problem(inputs)
	return en_home_usecases_item_3_problem(inputs)
});
export { home_usecases_item_3_problem as "home.usecases.item_3_problem" }